import { useState } from "react";
import { useSelector } from "react-redux";
import { getDocumentDownloadUrl } from "../pages/IEPFReport/ticketService";

const useDocumentViewer = () => {
  const [documentViewerModal, setDocumentViewerModal] = useState({
    open: false,
    documentUrl: null,
    documentName: "",
    documentType: "",
    isLoading: false,
    error: null,
  });

  const userId = useSelector((state)=>state.auth.user.userId)

  const handleDownloadFile = async (
    ticketCode,
    documentType = "entitlement_letter"
  ) => {
    const url = await getDocumentDownloadUrl(ticketCode, documentType,userId);
    if (!url) return;

    // Create a temporary <a> tag and trigger download
    const a = document.createElement("a");
    a.href = url;

    // Optional: Suggest a file name
    const filename = decodeURIComponent(url.split("/").pop().split("?")[0]);
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleViewDocument = async (
    ticketCode,
    documentName = "Document",
    documentType = "entitlement_letter"
  ) => {
    if (!ticketCode) return;

    setDocumentViewerModal({
      open: true,
      documentUrl: null,
      documentName,
      documentType,
      isLoading: true,
      error: null,
    });

    try {
      const url = await getDocumentDownloadUrl(ticketCode, documentType,userId);
      if (url) {
        setDocumentViewerModal((prev) => ({
          ...prev,
          documentUrl: url,
          isLoading: false,
        }));
      } else {
        setDocumentViewerModal((prev) => ({
          ...prev,
          isLoading: false,
          error: "Failed to load document",
        }));
      }
    } catch (err) {
      setDocumentViewerModal((prev) => ({
        ...prev,
        isLoading: false,
        error: "Failed to load document", // Fixed: was 'err' instead of 'error'
      }));
    }
  };

  const handleCloseDocumentViewer = () => {
    setDocumentViewerModal({
      open: false,
      documentUrl: null,
      documentName: "",
      documentType: "",
      isLoading: false,
      error: null,
    });
  };

  const resetDocumentViewer = () => {
    handleCloseDocumentViewer();
  };

  return {
    documentViewerModal,
    handleDownloadFile,
    handleViewDocument,
    handleCloseDocumentViewer,
    resetDocumentViewer,
  };
};

export default useDocumentViewer;
